export const role = {
  administrator: "Administrator",
  driver: "Driver",
  role: "Role",
  users: "Total Accounts",
  permission: "Permission",
  permissions: "'s Permissions",
};
